/* eslint-disable max-len */
import {
    Box,
    Text,
    VStack,
    Link,
    Button,
} from '@chakra-ui/react';
import { FaIcon } from '@acp/core-ui';
import { faCheckCircle } from '@fortawesome/sharp-light-svg-icons';
import { Link as RouterLink } from 'react-router-dom';
import { ServiceIdMapper, ServiceShortName } from '@acp/shared';
import { ReportedFindingsMachineContext } from '../machine/context';

function ResolvedByThirdPartyComplete() {
    const machine = ReportedFindingsMachineContext.useActorRef();

    const compliancePropertyId = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.compliancePropertyId
    );
    const serviceShortName = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.serviceShortName
    );

    const selectedProblemRegisterIds = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.thirdPartyResolutionForm.selectedProblemRegisterIds
    );

    const reportedFindings = ReportedFindingsMachineContext.useSelector(
        (state) => state.context.reportedFindings
    );

    const documentServiceCode = ServiceIdMapper.getDocumentServiceCode(serviceShortName);

    if (serviceShortName as ServiceShortName === ServiceShortName.MinimumStandards) {
        return (
            <VStack align="left" w="100%" spacing={4} mt={4}>
                <VStack w="100%" alignItems="center" gap={4} pb={10}>
                    <FaIcon w={12} h={12} icon={faCheckCircle} color="success.500" />
                    <Text fontWeight="medium">
                        {selectedProblemRegisterIds.length}
                        {' of '}
                        {reportedFindings.length}
                        {' reported findings submitted for re-assessment.'}
                    </Text>
                    {reportedFindings
                        ?.filter((finding) => selectedProblemRegisterIds.includes(
                            finding.problemRegister.problemRegisterId
                        ))
                        .map((finding) => (
                            <Text key={finding.problemRegister.problemRegisterId}>
                                {finding.originalProblemItem.title}
                            </Text>
                        ))}
                    <Box textAlign="center" mb={4} mt={2}>
                        <Text fontSize="sm" color="muted.700" maxW="md" display="inline-block">
                            <Box as="span" fontSize="sm" fontWeight="bold">Note:</Box>
                            {' '}
                            Our team may take up to 1 business day to review the documents you have provided. You will be notified once an updated asssessment is available.
                        </Text>
                    </Box>
                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                    <Link
                        _hover={{ textDecoration: 'underline' }}
                        fontWeight="normal"
                        fontSize="md"
                        color="muted.500"
                        mt={4}
                        onClick={() => machine.send({ type: 'RESOLVE_MORE' })}
                    >
                        <Text color="muted.700">
                            Return to findings page
                        </Text>
                    </Link>
                </VStack>
            </VStack>
        );
    }

    return (
        <VStack align="left" w="100%" spacing={4} mt={4}>
            <VStack w="100%" alignItems="center" gap={4} pb={10}>
                <FaIcon w={12} h={12} icon={faCheckCircle} color="success.500" />
                <Text fontWeight="medium">
                    {selectedProblemRegisterIds.length}
                    {' of '}
                    {reportedFindings.length}
                    {' reported findings marked as resolved by third party.'}
                </Text>
                {reportedFindings
                    ?.filter((finding) => selectedProblemRegisterIds.includes(
                        finding.problemRegister.problemRegisterId
                    ))
                    .map((finding) => (
                        <Text key={finding.problemRegister.problemRegisterId}>
                            {finding.originalProblemItem.title}
                        </Text>
                    ))}
                {/* TODO: "to" is not correct, need to implement new document type (e.g. 3rd party) in Documents tab on proprety details page */}
                {documentServiceCode !== undefined && (
                    <Button
                        as={RouterLink}
                        to={`/property/${compliancePropertyId}/documents?filter=THIRD_PARTY_RESOLUTION&service=${documentServiceCode}`}
                        colorScheme="black"
                        size="md"
                        variant="solid"
                    >
                        View updated documents
                    </Button>
                )}
                <Box textAlign="center" mb={4} mt={2}>
                    <Text fontSize="sm" color="muted.700" maxW="md" display="inline-block">
                        <Box as="span" fontSize="sm" fontWeight="bold">Note:</Box>
                        {' '}
                        If compliance issues remain unresolved,
                        the documents will be regenerated to reflect those outstanding items.
                    </Text>
                </Box>
                {/*
                    Does the Return to findings page, just close the modal or go somewhere else?
                    => Answer: Just to the beginning screen of the modal.
                    => No need hypelink here
                */}
                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                <Link
                    _hover={{ textDecoration: 'underline' }}
                    fontWeight="normal"
                    fontSize="md"
                    color="muted.500"
                    mt={4}
                    onClick={() => machine.send({ type: 'RESOLVE_MORE' })}
                >
                    <Text color="muted.700">
                        Return to findings page
                    </Text>
                </Link>
            </VStack>
        </VStack>
    );
}

export { ResolvedByThirdPartyComplete };
